module.exports = __webpack_public_path__ + "img/box.4eade343.svg";